module.exports = ".due-date-due {\r\n  color: red;\r\n}\r\n"